import { Tooltip } from 'antd';
import classNames from 'classnames';
import { IconFont } from '@/utils/utils';
import AvatarDropdown from './AvatarDropdown';
import AssetMonitor from './AssetMonitor';
import styles from './index.less';
import { useTranslation } from 'react-i18next';

import header_wechat from '@/assets/images/header_wechat.svg';
import online from '@/assets/images/header_online.svg';
import { Box } from './Box';
import wechat from '@/assets/images/wechat.svg';
import Track from '@/tracks';
import { openLinkAiChat } from '@/opsigenesSDK';

const GlobalHeaderRight: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={classNames('fx-v-c', styles.right)}>
      <div className={classNames('fx-v-c', styles.operate)}>
        <AssetMonitor />
        <a
          href="/partner"
          target="_blank"
          rel="noreferrer"
          className={classNames(
            'f-w-5',
            styles.seaSchool,
            'fx-v-c',
            styles.partner,
          )}
        >
          {t('luban_partner')}
        </a>
        <a
          href="https://luban-academy.bluemediagroup.cn/"
          target="_blank"
          rel="noreferrer"
          className={classNames('f-w-5', styles.seaSchool, 'fx-v-c')}
        >
          {t('overseas_college')}
        </a>
        <Tooltip title={t('help_center')}>
          <div className={classNames('fx-v-c', styles.helpCenter)}>
            <IconFont
              className="fz-20 c-p"
              type="icon-bangzhu"
              title={t('help_center')}
              onClick={() =>
                window.open(
                  '/guide',
                  '_blank',
                )
              }
            />
          </div>
        </Tooltip>
        <Tooltip title={t('online_consultant')}>
          <div
            className={classNames('fx-v-c', styles.online)}
            onClick={() => { Track.track('在线客服咨询'); openLinkAiChat(); }}
          >
            <img src={online} alt="" className='c-p'/>
          </div>
        </Tooltip>
        <Box
          imgSrc={header_wechat}
          title={t('follow_the_wechat_official_account')}
          desc={t('first_hand_policy_updates_in_real_time')}
          contentImg={wechat}
          onMouseOver={ () => Track.track('微信咨询') }
        />
      </div>
      <AvatarDropdown />
    </div>
  );
};
export default GlobalHeaderRight;
